/*
import {
  _hm,
  _ht,
  useGblz,
  l,
  f
} from 'lib';
*/
import * as cmFTH from "./_cmFTH"; // 廃止予定
import * as gs from "./_csGbl";
import * as _ht from './_ht';
import * as _hm from './_hf';

import * as ihd from './ihd';

export const ilzI15z = () => ({
  i15rz: {},
  i151s: [],
  i152s: [],
}) as _ht.dz;

export const crtI15zAsync = async () => {
  const _gUserz = gs.useGblz('user');
  const _i15z = ilzI15z();
  _hm.udtDz(_i15z.i15rz, {
    ... ihd.i('i15r'),
    i15r_31r1f: _gUserz.crt._31rz._fst,
  });
  _i15z.i151s = [];
  _i15z.i152s = [];
  return _i15z;
};

export const loadI15rLsAsync = async (pz?: {
  _31r_fst: _ht.n,
  yearMth: _ht.s,
  i1zrs1100iMnm?: _ht.n,
  lwrType: _ht.n,
}) => {
  _hm.logOst('icvI15___Mz.loadI15rLsAsync -> _ihdI15.grtPzForLoadI15rPs');
//  const _gUserz = useGblz('user');
  const _ls = await cmFTH.loadLsAsync({
    tgt: 'i15rs',
//    cdn: cmFTH.vdd() + ` AND i15r_31r1f=${_gUserz.crt._31rz._fst}`,
    cdn: cmFTH.vdd(), // 全体共通
    lwrz: 
      pz?.lwrType == 1 ? // 実績集計表
      {
        i18rs: {
          tgt: 'i18rs',
//            AND i18r_31r1f = ${pz._31r_fst} 
          cdn: cmFTH.vdd() + ` 
            AND i18ri15r1f = {i15r_fst}
          `, // _31r_fst は i18r でなく i1zr に適用
          rlcz: {
            i15r_fst: 'i15rs._fst',
          },
          lwrz: {
            i1zrs: {
              tgt: 'i1zrs',
              cdn: cmFTH.vdd() + `
                AND i1zr_31r1f = ${pz._31r_fst}
                AND i1zri18r1f = {i18r_fst}
                AND i1zrs1100i >= ${pz.i1zrs1100iMnm}
                AND i1zrd3100s LIKE '${pz?.yearMth}%'
              `,
              rlcz: {
                i18r_fst: 'i18rs._fst'
              },
              lwrz: {
                i1z1s: {
                  tgt: 'i1z1s',
                  cdn: cmFTH.vdd(false) + `
                    AND i1z1i1zr1k = {i1zr_key}
                  `,
                  rlcz: {
                    i1zr_key: 'i1zrs._key',
                  }
                },
                i1z4s: {
                  tgt: 'i1z4s',
                  cdn: cmFTH.vdd(false) + `
                    AND i1z4i1zr1k = {i1zr_key}
                  `,
                  rlcz: {
                    i1zr_key: 'i1zrs._key',
                  }
                }
              }
            }
          }
        }
      } 
      : undefined,
  });
  return _ls;
};

export const loadI15rDzAsync = async ( pz?: {
  i15r_fst?: _ht.n, // 特定の団体の団体種別
  i18r_fst?: _ht.n, // 特定の団体の団体種別
  vsn?: _ht.n,
} ) => {
  _hm.logOst('icvI15___Mz.loadI15rDzAsync -> _ihdI15.grtPzForLoadI15rPs');
//  const _gUserz = useGblz('user');
//  let _cdn = cmFTH.vdd() + ` AND i15r_31r1f=${_gUserz.crt._31rz._fst}`;
  let _cdn = (pz?.vsn && pz?.vsn > 0) ? (cmFTH.vdd(false) + ` AND _vsn = ${pz?.vsn}`) : cmFTH.vdd();
  if (pz?.i15r_fst) _cdn += ` AND _fst = ${pz.i15r_fst}`;
  if (pz?.i18r_fst) _cdn += ` AND _fst = (SELECT i18ri15r1f FROM i18rs WHERE ${cmFTH.vdd() + ` AND _fst = ${pz.i18r_fst}`})`
//hf.l(`icvI15___Mz 104: ${_cdn}`)
  const _dz = await cmFTH.loadDzAsync({
    tgt: 'i15rs',
    cdn: _cdn,
    lwrz: {
      i151s: {
        tgt: 'i151s',
        cdn: cmFTH.vdd(false) + ` AND i151i15r1k={i15r_key}`,
        rlcz: {
          i15r_key: 'i15rs._key',
        },
      },
      i152s: {
        tgt: 'i152s',
        cdn: cmFTH.vdd(false) + ` AND i152i15r1k={i15r_key}`,
        rlcz: {
          i15r_key: 'i15rs._key',
        },
      }
    }
  })
  return {
    i15rz: { ... _dz, cldz: undefined },
    i151s: _dz.cldz?.i151s ?? [],
    i152s: _dz.cldz?.i152s ?? [],
  };
};

export const saveI15rDzAsync = async (pz: {
  i15z: _ht.dz,
  sPz?: _ht.dz,
}) => {
  const _dz = await cmFTH.ugdDzAsync({
    tgt: 'i15rs',
    dz: {
      ... pz.i15z.i15rz,
    },
    lwrz: {
      i151s: {
        tgt: 'i151s',
        ls: pz.i15z.i151s,
        udtz: {
          i151i15r1k: 'i15rs._key',
        }
      },
      i152s: {
        tgt: 'i152s',
        ls: pz.i15z.i152s,
        udtz: {
          i152i15r1k: 'i15rs._key',
        }
      }
    }
  });
  return {
    i15rz: { ... _dz, cldz: undefined, }
  };
};
